import { Divider } from "antd";
import { useIntl } from "react-intl";
import { Link, useParams } from "react-router-dom";
import { StyledButton } from "~Common/Components";
import PermissionCheck from "~Common/PermissionCheck";
import { TableRowActionDelete } from "~components/DataTable/components/TableRowActionDelete/TableRowActionDelete.tsx";
import { TableRowActionLink } from "~components/DataTable/components/TableRowActionLink/TableRowActionLink.tsx";
import { TableRowActionsMenu } from "~components/DataTable/components/TableRowActionsMenu/TableRowActionsMenu.tsx";
import type { TableRowActionsMenuItem } from "~components/DataTable/types/tableRowActionsMenuItem.ts";
import { useUserPermissions } from "~context/UserPermissionsContext";
import { PermissionNames, PermissionOperations } from "~enums/permissions.ts";

type Props = {
  competitionId: string;
  handleDelete: (competitionId: string) => void;
  isDeletePending: boolean;
  nameLocal: string;
};
export const ActionColumns = ({ competitionId, handleDelete, nameLocal, isDeletePending }: Props) => {
  const { customerId, sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const { hasPermission } = useUserPermissions();

  const hasPermissionToUpdate = hasPermission(PermissionNames.COMPETITION, PermissionOperations.UPDATE);
  const hasPermissionToDelete = hasPermission(PermissionNames.COMPETITION, PermissionOperations.DELETE);

  const tableRowActionsMenuItems: TableRowActionsMenuItem[] = [];

  if (hasPermissionToUpdate) {
    tableRowActionsMenuItems.push({
      key: "manage",
      label: (
        <TableRowActionLink
          to={`/${customerId}/admin/${sport}/${organizationId}/competition/manage/${competitionId}/`}
          linkLabelIntl={`manage`}
          icon={<i className="fas  fa-eye mr-2" />}
        />
      ),
    });
  }

  if (hasPermissionToDelete) {
    tableRowActionsMenuItems.push({
      key: "divider-1",
      label: <Divider style={{ margin: 0 }} />,
    });
    tableRowActionsMenuItems.push({
      key: "delete",
      label: (
        <TableRowActionDelete
          icon={<i className="fas fa-trash-can mr-2" />}
          handleDelete={() => handleDelete(competitionId)}
          loading={isDeletePending}
          itemName={nameLocal}
        />
      ),
    });
  }

  return (
    <>
      <PermissionCheck permissionKeys={[PermissionNames.SEASON]}>
        <Link to={`/${customerId}/admin/${sport}/${organizationId}/competition/${competitionId}/seasons/`}>
          <StyledButton type={"text"}>
            {formatMessage({
              id: "seasons",
              defaultMessage: "Seasons",
            })}
          </StyledButton>
        </Link>
      </PermissionCheck>
      <TableRowActionsMenu tableRowActionsMenuItems={tableRowActionsMenuItems} />
    </>
  );
};
